import { useAppSelector } from '../../slices/store';
import { UserLoginForm } from './UserLoginForm/UserLoginForm';
import { Stage } from './Stage/Stage';
import { getWebSocket, setupWebSocket } from '../../socket/socket';
import { useEffect } from 'react';
import { TMusicMafiaURL } from '../../utils/types';
import { useParams } from 'react-router-dom';
import { StyledMusicMafia } from './styles';
import { useCookies } from '../../hooks/useCookies';
import { useDispatch } from 'react-redux';
import { setIsAdmin, setUserId } from '../../slices/main/mainSlice';

export const MusicMafia = () => {
  const {isAdmin, stage, userId} = useAppSelector((s) => s.mainStore);
  const dispatch = useDispatch();

  const { roomId } = useParams<TMusicMafiaURL>();

  const userIdCookie = useCookies('userId');
  const roomIdCookie = useCookies('roomId');
  const isAdminCookie = useCookies('isAdmin');

  useEffect(() => {
    if (!getWebSocket() && roomId) {
      // case: no socket connection was established earlier (page reload happened or user first time entered room link)

      if (roomId !== roomIdCookie.cookieValue && roomIdCookie.cookieValue) {
        // sub-case: enter new room with old cookies
        userIdCookie.deleteCookie();
        isAdminCookie.deleteCookie();
        roomIdCookie.deleteCookie();
      } else if (userIdCookie.cookieValue && isAdminCookie.cookieValue) {
        // sub-case: reenter current room using correct cookies
        const newIsAdmin = isAdminCookie.cookieValue === "true";
        
        dispatch(setIsAdmin(newIsAdmin));
        dispatch(setUserId(userIdCookie.cookieValue));
        
        setupWebSocket(roomId, userIdCookie.cookieValue, newIsAdmin);
      }
    }
    
    if (userId && roomId) {
      // case: enter new room
      userIdCookie.setCookie(userId);
      isAdminCookie.setCookie(`${isAdmin}`);
      roomIdCookie.setCookie(roomId);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userIdCookie.cookieValue, isAdminCookie.cookieValue, roomIdCookie.cookieValue, 
    // userId, isAdmin, 
    roomId, dispatch])
  
  return (
    <StyledMusicMafia>
      {!isAdmin && !userId && <UserLoginForm />}
      {!!stage && <Stage />}
    </StyledMusicMafia>
  )
}
